var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "after-sales" }, [
    _c("div", { staticClass: "after-sales-content" }, [
      _c("div", { staticClass: "after-sales-title" }, [
        _c("div", { staticClass: "medium" }, [
          _vm._v(_vm._s(_vm.message.username))
        ]),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.message.createAt))])
      ]),
      _vm._v(" "),
      _vm.status === 6
        ? _c("div", { staticClass: "after-sales-name" }, [
            _vm._v(
              "\n    The Retailer (" +
                _vm._s(_vm.message.username) +
                ") created a refund request on " +
                _vm._s(_vm.message.createAt) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.status === 80
        ? _c("div", { staticClass: "after-sales-name" }, [
            _vm._v("\n    Modified after-sales application\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "after-sales-reason" }, [
        _c("div", [_vm._v("Refund type:  Refund")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("Refund amount: $" + _vm._s(_vm.message.refundTotalAmount))
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("Reason for refund: " + _vm._s(_vm.message.reason))]),
        _vm._v(" "),
        _c("div", [
          _vm._v("Description of refund: " + _vm._s(_vm.message.submitFeedback))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d0bc5a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d0bc5a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/service-order/components/history-list/after-sales.vue
// module id = ORy/
// module chunks = 2